import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { DefaultLayout, ErrorPage } from '@maia/ui';
import Cookies from 'js-cookie';
import { getSelf } from '../features/broker/get-self/queryOptions';
import { getFullName } from '@maia/utils';
import { formatExceptionToTitleAndDescription } from '@maia/exceptions';
import { Logger } from '@maia/logger';
import { DocumentPreview } from '../features/shared/document/document-preview';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location }) => {
    const cookies = Cookies.get('auth_tokens');
    if (!cookies) {
      Cookies.remove('auth_tokens');
      throw redirect({
        to: '/',
      });
    }
    const { accessToken } = JSON.parse(cookies);
    if (!accessToken) {
      throw redirect({
        to: '/',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  loader: async ({ context: { queryClient } }) => {
    const me = await queryClient.ensureQueryData(getSelf());

    return {
      me: me,
    };
  },
  wrapInSuspense: true,
  component: Page,
  notFoundComponent: () => <NotFoundComponent />,
  errorComponent: ({ error }) => <ErrorComponent thrownError={error} />,
});

function Page() {
  const { me } = Route.useLoaderData();
  const navigate = Route.useNavigate();

  Logger.setUser({ guid: me.guid });

  return (
    <DefaultLayout
      name={getFullName(me)}
      initials={me.initials}
      onLogout={() => {
        Cookies.remove('auth_tokens');
        return navigate({ to: '/' });
      }}
    >
      <Outlet />
      <DocumentPreview />
    </DefaultLayout>
  );
}

function ErrorComponent({ thrownError }: { thrownError: Error }) {
  const navigate = Route.useNavigate();

  return (
    <DefaultLayout
      name=""
      initials=""
      onLogout={() => {
        Cookies.remove('auth_tokens');
        return navigate({ to: '/' });
      }}
    >
      <ErrorPage
        action={{
          type: 'link',
          to: '/dashboard',
          title: 'Terug naar dashboard',
        }}
        {...formatExceptionToTitleAndDescription(thrownError)}
      />
    </DefaultLayout>
  );
}

function NotFoundComponent() {
  const navigate = Route.useNavigate();

  return (
    <DefaultLayout
      name=""
      initials=""
      onLogout={() => {
        Cookies.remove('auth_tokens');
        return navigate({ to: '/' });
      }}
    >
      <ErrorPage
        title="Pagina niet gevonden"
        description="Oops, deze pagina kunnen wij niet meer vinden of bestaat niet meer"
        action={{
          type: 'link',
          to: '/dashboard',
          title: 'Terug naar dashboard',
        }}
      />
    </DefaultLayout>
  );
}
